'use client';

import { Avatar } from 'antd';
import styled from 'styled-components';
import { IUser } from '@type/user';

const ProfileAvatar = styled(Avatar)`
  margin-top: -40px;
  border: 2px solid white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`;

export function ProfileHeader({ user }: { user: IUser }) {
  return (
    <div className="py-6">
      <div className="flex flex-col justify-center items-center gap-3">
        <ProfileAvatar className="!bg-orange-600" src={user?.avatar || null} size={120}>
          {user?.name?.charAt(0)?.toUpperCase() || user?.email?.charAt(0)?.toUpperCase()}
        </ProfileAvatar>
        <h1 className="typography-h3 font-semibold">{user?.name || user?.email}</h1>
      </div>
    </div>
  );
}
